import { render, staticRenderFns } from "./AbDropzone.vue?vue&type=template&id=10f3b9f8"
import script from "./AbDropzone.vue?vue&type=script&lang=js"
export * from "./AbDropzone.vue?vue&type=script&lang=js"
import style0 from "./AbDropzone.vue?vue&type=style&index=0&id=10f3b9f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports